import React, { useState } from "react";
import {
  COPY_LINK,
  SHARE_WIDGET_DATA,
  SOCIAL_MEDIA_PLATFORMS,
} from "./shareWidget.constants";
import "./shareWidget.scss";
import CopyLink from "../../../assets/images/copy-link.svg";
import Share from "../../../assets/images/share.svg";
import PropTypes from "prop-types";
import CloseIcon from "../../../assets/images/icons/ic_close.svg";
import { COPY_TO_CLIPBOARD_TITLE } from "./shareWidget.constants";
import { isMobile } from "../../../utils/breakPoints";
import { triggerBuzzClickEvent } from "../../../utils/garfieldHelpers";
import {
  EVENT_NAMES,
  PLATFORM,
} from "../../../constants/garfieldEvents";

const ShareWidget = ({
  showSolidBorder,
  url,
  title,
  text,
  sectionId,
  source,
  flow,
}) => {
  const [showClipboard, setShowClipboard] = useState(false);

  const closeClipboard = () => {
    setShowClipboard(false);
  };

  const handleCopyLink = shareLink => {
    navigator?.clipboard?.writeText(shareLink);
    setShowClipboard(true);
    triggerBuzzClickEvent(
      EVENT_NAMES.COPY_ARTICLE_LINK_CLICKED,
      {
        [SHARE_WIDGET_DATA.TITLE]: title,
        [SHARE_WIDGET_DATA.COPY_LINK]: shareLink,
      },
      sectionId,
      source,
      flow
    );
    setTimeout(() => {
      setShowClipboard(false);
    }, 1500);
  };

  const shareOnMobile = () => {
    if (!isMobile()) {
      return;
    }
    triggerBuzzClickEvent(
      EVENT_NAMES.SHARE_WIDGET_MOBILE_CLICKED,
      {
        [SHARE_WIDGET_DATA.TITLE]: title,
        [SHARE_WIDGET_DATA.PLATFORM]: PLATFORM.MOBILE,
      },
      sectionId,
      source,
      flow
    );
    const shareData = {
      url,
      title,
      text,
    };
    navigator?.share(shareData);
  };

  const triggerShareWidgetDesktop = (
    socialMediaPlatform,
    shareUrl
  ) => {
    triggerBuzzClickEvent(
      EVENT_NAMES.SHARE_WIDGET_DESKTOP_CLICKED,
      {
        [SHARE_WIDGET_DATA.TITLE]: title,
        [SHARE_WIDGET_DATA.SOCIAL_PLATFORM]: socialMediaPlatform,
        [SHARE_WIDGET_DATA.URL]: shareUrl,
      },
      sectionId,
      source,
      flow
    );
  };

  return (
    <>
      <div
        className={`share-widget-wrapper ${
          showSolidBorder ? "solid-border" : ""
        }`}
      >
        <div className="share" onClick={shareOnMobile}>
          <span className="title">Share</span>
          <img src={Share} className="share-icon" />
        </div>

        <div className="social-media-items">
          {SOCIAL_MEDIA_PLATFORMS.map(item => {
            const shareUrl = item?.getShareUrl(
              url,
              item.id
            );
            return (
              <a
                key={item.id}
                className="social-share-item"
                href={shareUrl}
                onClick={() =>
                  triggerShareWidgetDesktop(
                    item.id,
                    shareUrl
                  )
                }
              >
                <img src={item.img} alt={item.title} />
              </a>
            );
          })}
        </div>
        <span className="separator">|</span>
        <button
          className="copy-link"
          onClick={() => handleCopyLink(url)}
        >
          <img src={CopyLink} alt={COPY_LINK} />
          <span className="copy-link-text">
            {COPY_LINK}
          </span>
        </button>
      </div>

      <div
        className={`clipboard-text ${
          showClipboard ? "fade-in" : "fade-out"
        }`}
      >
        <div>
          <span className="title">
            {COPY_TO_CLIPBOARD_TITLE} :
          </span>{" "}
          <span className="link">{url}</span>
        </div>
        <button className="close" onClick={closeClipboard}>
          <img src={CloseIcon} alt="close-icon" />
        </button>
      </div>
    </>
  );
};

ShareWidget.propTypes = {
  showSolidBorder: PropTypes.bool,
  url: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  sectionId: PropTypes.string,
  source: PropTypes.string,
  flow: PropTypes.string,
};

export default ShareWidget;
